<script>
	import { browser } from '$app/environment';
	
	const baseUrl = 'https://dailyexpress.com.my';
	
	let newsDropdownOpen = false;
	let featuresDropdownOpen = false;
	let lifestyleDropdownOpen = false;
	let mobileMenuOpen = false;
	let mobileNewsOpen = true;
	let mobileFeaturesOpen = true;
	let mobileLifestyleOpen = true;
	
	function toggleNewsDropdown() {
		newsDropdownOpen = !newsDropdownOpen;
		featuresDropdownOpen = false;
		lifestyleDropdownOpen = false;
	}
	
	function toggleFeaturesDropdown() {
		featuresDropdownOpen = !featuresDropdownOpen;
		newsDropdownOpen = false;
		lifestyleDropdownOpen = false;
	}
	
	function toggleLifestyleDropdown() {
		lifestyleDropdownOpen = !lifestyleDropdownOpen;
		newsDropdownOpen = false;
		featuresDropdownOpen = false;
	}
	
	function closeAllDropdowns() {
		newsDropdownOpen = false;
		featuresDropdownOpen = false;
		lifestyleDropdownOpen = false;
	}
	
	function toggleMobileMenu() {
		mobileMenuOpen = !mobileMenuOpen;
		// Keep sub-menus open when menu is closed and reopened
		if (!mobileMenuOpen) {
			// Don't close sub-menus, they should stay open
		}
	}
	
	function toggleMobileNews() {
		mobileNewsOpen = !mobileNewsOpen;
		mobileFeaturesOpen = false;
		mobileLifestyleOpen = false;
	}
	
	function toggleMobileFeatures() {
		mobileFeaturesOpen = !mobileFeaturesOpen;
		mobileNewsOpen = false;
		mobileLifestyleOpen = false;
	}
	
	function toggleMobileLifestyle() {
		mobileLifestyleOpen = !mobileLifestyleOpen;
		mobileNewsOpen = false;
		mobileFeaturesOpen = false;
	}
	
	// Prevent body scroll when mobile menu is open
	$: if (browser) {
		if (mobileMenuOpen) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
	}
</script>

<nav class="border-b border-gray-200 navbar bg-base-100">
	<div class="container px-4 mx-auto">
		<div class="flex flex-col w-full">
			<!-- Logo and Title -->
			<div class="flex flex-col gap-2 justify-center items-center py-4 md:flex-row md:gap-4">
				<!-- Logo and LIVE -->
				<div class="flex gap-4 items-center">
					<a class="flex items-center navbar-brand" href="{baseUrl}/">
						<img 
							src="/daily-express-2024-inline.png" 
							alt="Daily Express Malaysia"  
							class="inline-block h-6 align-text-top md:h-auto"
						/>
					</a>
				</div>
				
				<!-- Title -->
				<div class="text-2xl text-center font-bold text-[#4284d6]">Sabah Election 2025 <span class="inline md:hidden"><br/></span>Live Results</div>
			</div>

			<!-- Desktop Navigation Menu (hidden on tablet and below) -->
			<div class="hidden justify-center">
				<ul class="flex gap-2 items-center my-0 font-semibold navbar-nav">
				<li class="text-sm nav-item pe-2 ps-0">
					<a class="flex items-center transition-colors nav-link hover:text-primary" href="{baseUrl}/">
						<svg class="mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
							<path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
						</svg>
						Home
					</a>
				</li>

				<!-- News Dropdown with Megamenu -->
				<li class="relative text-sm nav-item pe-2 dropdown">
					<button 
						class="flex items-center transition-colors nav-link dropdown-toggle hover:text-primary" 
						on:click={toggleNewsDropdown}
						on:blur={() => setTimeout(closeAllDropdowns, 200)}
					>
						News
						<svg class="ml-1 w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
						</svg>
					</button>
					{#if newsDropdownOpen}
						<div class="dropdown-menu megamenu absolute top-full left-0 mt-2 bg-gray-50 text-sm z-50 shadow-lg rounded-lg p-4 min-w-[800px] max-w-[calc(100vw-2rem)]">
							<div class="grid grid-cols-1 gap-4 lg:grid-cols-4">
								<div class="col-span-1 lg:col-span-1">
									<div class="text-sm col-megamenu">
										<a class="block mb-3 font-semibold text-dark hover:text-primary" href="{baseUrl}/local/">Sabah News</a>
										<div class="grid grid-cols-2 gap-3">
											<div class="col-span-1">
												<ul class="space-y-2 text-sm list-none">
													<li><a href="{baseUrl}/local/?location='Keningau'" class="text-secondary hover:text-primary">Keningau</a></li>
													<li><a href="{baseUrl}/local/?location='Kota Belud'" class="text-secondary hover:text-primary">Kota Belud</a></li>
													<li><a href="{baseUrl}/local/?location='Kota Kinabalu'" class="text-secondary hover:text-primary">Kota Kinabalu</a></li>
													<li><a href="{baseUrl}/local/?location='Labuan'" class="text-secondary hover:text-primary">Labuan</a></li>
													<li><a href="{baseUrl}/local/?location='Lahad Datu'" class="text-secondary hover:text-primary">Lahad Datu</a></li>
													<li><a href="{baseUrl}/local/?location='Papar'" class="text-secondary hover:text-primary">Papar</a></li>
												</ul>
											</div>
											<div class="col-span-1">
												<ul class="space-y-2 text-sm list-none">
													<li><a href="{baseUrl}/local/?location='Ranau'" class="text-secondary hover:text-primary">Ranau</a></li>
													<li><a href="{baseUrl}/local/?location='Sandakan'" class="text-secondary hover:text-primary">Sandakan</a></li>
													<li><a href="{baseUrl}/local/?location='Tawau'" class="text-secondary hover:text-primary">Tawau</a></li>
													<li><a href="{baseUrl}/local/?location='Tenom'" class="text-secondary hover:text-primary">Tenom</a></li>
													<li><a href="{baseUrl}/local/?location='Tuaran'" class="text-secondary hover:text-primary">Tuaran</a></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div class="col-span-1 lg:col-span-1">
									<div class="text-sm col-megamenu">
										<a class="block mb-3 font-semibold text-dark hover:text-primary" href="{baseUrl}/national/">National News</a>
										<div class="grid grid-cols-1 gap-3">
											<div class="col-span-1">
												<ul class="space-y-2 text-sm list-none">
													<li><a href="{baseUrl}/sarawak/" class="text-secondary hover:text-primary">Sarawak</a></li>
													<li><a href="{baseUrl}/west-malaysia/" class="text-secondary hover:text-primary">West Malaysia</a></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div class="col-span-1 lg:col-span-1">
									<div class="text-sm col-megamenu">
										<a class="block mb-3 font-semibold text-dark hover:text-primary" href="{baseUrl}/asean/">ASEAN News</a>
									</div>
								</div>
								<div class="col-span-1 lg:col-span-1">
									<div class="text-sm col-megamenu">
										<a class="block mb-3 font-semibold text-dark hover:text-primary" href="{baseUrl}/world/">World News</a>
									</div>
								</div>
							</div>
						</div>
					{/if}
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/epaper/">E-paper</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/videos/">Videos</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/business/">Business</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/sports/">Sports</a>
				</li>

				<!-- Features Dropdown -->
				<li class="relative text-sm nav-item pe-2 dropdown">
					<button 
						class="flex items-center transition-colors nav-link dropdown-toggle hover:text-primary" 
						on:click={toggleFeaturesDropdown}
						on:blur={() => setTimeout(closeAllDropdowns, 200)}
					>
						Features
						<svg class="ml-1 w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
						</svg>
					</button>
					{#if featuresDropdownOpen}
						<ul class="dropdown-menu absolute top-full right-0 mt-2 bg-gray-50 text-sm z-50 shadow-lg rounded-lg py-2 min-w-[200px] max-w-[calc(100vw-2rem)]">
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/hotline/">Hotline</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/sabah-in-history/">Sabah in History</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/special/">Special Reports</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/opinions/">Opinions</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/forum/">Forum</a></li>
						</ul>
					{/if}
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/property/">Property</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/auto/">Auto</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/education/">Education</a>
				</li>

				<!-- Lifestyle Dropdown -->
				<li class="relative text-sm nav-item pe-2 dropdown">
					<button 
						class="flex items-center transition-colors nav-link dropdown-toggle hover:text-primary" 
						on:click={toggleLifestyleDropdown}
						on:blur={() => setTimeout(closeAllDropdowns, 200)}
					>
						Lifestyle
						<svg class="ml-1 w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
			</svg>
					</button>
					{#if lifestyleDropdownOpen}
						<ul class="dropdown-menu absolute top-full right-0 mt-2 bg-gray-50 text-sm z-50 shadow-lg rounded-lg py-2 min-w-[200px] max-w-[calc(100vw-2rem)]">
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/food/">Food & Drink</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/health/">Health & Fitness</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/tech/">Tech & Gadgets</a></li>
							<li><a class="block px-4 py-2 font-semibold dropdown-item hover:bg-gray-100 hover:text-primary" href="{baseUrl}/travel/">Travel</a></li>
						</ul>
					{/if}
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/branded/">Branded</a>
				</li>

				<li class="text-sm nav-item pe-2">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/harian/">Harian Ekspres</a>
				</li>

				<li class="text-sm nav-item pe-0">
					<a class="transition-colors nav-link hover:text-primary" href="{baseUrl}/search/">Search</a>
				</li>
				</ul>
			</div>
		</div>
	</div>
	
	<!-- Mobile Menu Overlay -->
	{#if mobileMenuOpen}
		<div 
			class="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
			role="button"
			tabindex="0"
			aria-label="Close menu"
			on:click={toggleMobileMenu}
			on:keydown={(e) => e.key === 'Escape' && toggleMobileMenu()}
		></div>
	{/if}
	
	<!-- Mobile Sidebar Menu (slides in from left) -->
	<div class="mobile-menu fixed top-0 left-0 h-full w-full bg-gray-100 z-50 transform transition-transform duration-300 ease-in-out lg:hidden {mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} overflow-y-auto">
		<!-- Mobile Menu Header with Logo and Hamburger -->
		<div class="flex justify-between items-center p-4 bg-white border-b border-gray-300">
			<!-- Logo -->
			<a class="flex items-center navbar-brand" href="{baseUrl}/" on:click={toggleMobileMenu}>
				<img 
					src="/daily-express-2024-inline.png" 
					alt="Daily Express Malaysia"  
					class="inline-block align-text-top"
				/>
			</a>
			
			<!-- Hamburger Close Button -->
			<button 
				class="p-2 text-gray-700 transition-colors hover:text-primary"
				on:click={toggleMobileMenu}
				aria-label="Close menu"
			>
				<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
				</svg>
			</button>
		</div>
		
		<ul class="font-bold list-none">
			<!-- Home -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
						<path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
					</svg>
					Home
				</a>
			</li>
			
			<!-- News -->
			<li class="bg-gray-200">
				<div class="flex items-center p-3 text-dark">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					News
				</div>
			</li>
			
				<!-- Sabah News -->
				<li class="bg-gray-300">
					<a href="{baseUrl}/local/" class="block p-3 pl-8 font-semibold text-dark">Sabah News</a>
					<div class="py-2 bg-white">
						<div class="grid grid-cols-2">
							<div class="pl-8">
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/local/?location='Keningau'" class="text-dark hover:text-primary">Keningau</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Kota Belud'" class="text-dark hover:text-primary">Kota Belud</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Kota Kinabalu'" class="text-dark hover:text-primary">Kota Kinabalu</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Labuan'" class="text-dark hover:text-primary">Labuan</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Lahad Datu'" class="text-dark hover:text-primary">Lahad Datu</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Papar'" class="text-dark hover:text-primary">Papar</a></li>
								</ul>
							</div>
							<div>
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/local/?location='Ranau'" class="text-dark hover:text-primary">Ranau</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Sandakan'" class="text-dark hover:text-primary">Sandakan</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Tawau'" class="text-dark hover:text-primary">Tawau</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Tenom'" class="text-dark hover:text-primary">Tenom</a></li>
									<li class="py-1"><a href="{baseUrl}/local/?location='Tuaran'" class="text-dark hover:text-primary">Tuaran</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>
				
				<!-- National News -->
				<li class="bg-gray-300">
					<a href="{baseUrl}/national/" class="block p-3 pl-8 font-semibold text-dark">National News</a>
					<div class="py-2 bg-white">
						<div class="grid grid-cols-2">
							<div class="pl-8">
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/sarawak/" class="text-dark hover:text-primary">Sarawak</a></li>
								</ul>
							</div>
							<div>
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/west-malaysia/" class="text-dark hover:text-primary">West Malaysia</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>
				
				<!-- ASEAN News -->
				<li class="bg-gray-300">
					<a href="{baseUrl}/asean/" class="block p-3 pl-8 font-semibold text-dark">ASEAN News</a>
				</li>
				
				<!-- World News -->
				<li class="bg-gray-300">
					<a href="{baseUrl}/world/" class="block p-3 pl-8 font-semibold text-dark">World News</a>
				</li>
			
			<!-- E-paper -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/epaper/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					E-paper
				</a>
			</li>
			
			<!-- Videos -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/videos/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Videos
				</a>
			</li>
			
			<!-- Business -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/business/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Business
				</a>
			</li>
			
			<!-- Sports -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/sports/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Sports
				</a>
			</li>
			
			<!-- Features -->
			<li class="bg-gray-200">
				<div class="flex items-center p-3 text-dark">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Features
				</div>
			</li>
			
				<li class="bg-gray-300">
					<div class="py-2 bg-white">
						<div class="grid grid-cols-2">
							<div class="pl-8">
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/hotline/" class="text-dark hover:text-primary">Hotline</a></li>
									<li class="py-1"><a href="{baseUrl}/sabah-in-history/" class="text-dark hover:text-primary">Sabah in History</a></li>
									<li class="py-1"><a href="{baseUrl}/special/" class="text-dark hover:text-primary">Special Reports</a></li>
								</ul>
							</div>
							<div>
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/opinions/" class="text-dark hover:text-primary">Opinions</a></li>
									<li class="py-1"><a href="{baseUrl}/forum/" class="text-dark hover:text-primary">Forum</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>
			
			<!-- Property -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/property/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Property
				</a>
			</li>
			
			<!-- Auto -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/auto/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Auto
				</a>
			</li>
			
			<!-- Education -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/education/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Education
				</a>
			</li>
			
			<!-- Lifestyle -->
			<li class="bg-gray-200">
				<div class="flex items-center p-3 text-dark">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Lifestyle
				</div>
			</li>
			
				<li class="bg-gray-300">
					<div class="py-2 bg-white">
						<div class="grid grid-cols-2">
							<div class="pl-8">
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/food/" class="text-dark hover:text-primary">Food & Drink</a></li>
									<li class="py-1"><a href="{baseUrl}/health/" class="text-dark hover:text-primary">Health & Fitness</a></li>
								</ul>
							</div>
							<div>
								<ul class="font-normal list-none">
									<li class="py-1"><a href="{baseUrl}/tech/" class="text-dark hover:text-primary">Tech & Gadgets</a></li>
									<li class="py-1"><a href="{baseUrl}/travel/" class="text-dark hover:text-primary">Travel</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>
			
			<!-- Branded -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/branded/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Branded
				</a>
			</li>
			
			<!-- Harian Ekspres -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/harian/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Harian Ekspres
				</a>
			</li>
			
			<!-- Search -->
			<li class="bg-gray-200">
				<a href="{baseUrl}/search/" class="flex items-center p-3 text-dark hover:bg-gray-300">
					<svg class="mr-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
						<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
					</svg>
					Search
				</a>
			</li>
		</ul>
	</div>
</nav>

<style>
	.navbar {
		position: relative;
	}
	
	.nav-link {
		text-decoration: none;
		color: inherit;
		padding: 0.5rem 0.25rem;
		display: inline-flex;
		align-items: center;
		white-space: nowrap;
	}
	
	.nav-link svg {
		flex-shrink: 0;
		vertical-align: middle;
	}
	
	.dropdown-menu {
		animation: fadeIn 0.2s ease-in-out;
	}
	
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
	
	.megamenu {
		border: 1px solid #e5e7eb;
		/* Ensure megamenu doesn't overflow viewport */
		left: 0;
		right: auto;
	}
	
	/* On smaller screens, ensure dropdowns don't overflow */
	@media (max-width: 1024px) {
		.megamenu {
			min-width: auto;
			width: calc(100vw - 2rem);
		}
	}
	
	/* Ensure right-aligned dropdowns don't overflow on the left */
	.dropdown-menu {
		white-space: nowrap;
	}
	
	/* Mobile menu styles */
	.mobile-menu {
		box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
	}
	
	/* Prevent body scroll when mobile menu is open */
	:global(body.menu-open) {
		overflow: hidden;
	}
</style>